<script setup></script>

<template>
  <button class="btn-hamburger"><span /></button>
</template>
